import { render, staticRenderFns } from "./book-selector.vue?vue&type=template&id=6a18c172"
import script from "./book-selector.vue?vue&type=script&lang=ts"
export * from "./book-selector.vue?vue&type=script&lang=ts"
import style0 from "./book-selector.vue?vue&type=style&index=0&id=6a18c172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports